var _rect, _path, _rect2, _path2, _rect3, _path3, _rect4, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftAndRightArrowsMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 36,
    viewBox: "0 0 57 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.7143,
    width: 17.1428,
    height: 17.1428,
    rx: 3,
    fill: "black",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1041 4.67875C28.1756 4.5239 28.3957 4.5239 28.4673 4.67875L31.1238 10.4303C31.185 10.5629 31.0882 10.7142 30.9422 10.7142H25.6291C25.4832 10.7142 25.3864 10.5629 25.4476 10.4303L28.1041 4.67875Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7143,
    y: 18.8569,
    width: 17.1428,
    height: 17.1429,
    rx: 3,
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4673 31.3208C28.3958 31.4756 28.1757 31.4756 28.1042 31.3208L25.4476 25.5692C25.3864 25.4366 25.4832 25.2853 25.6292 25.2853H30.9423C31.0883 25.2853 31.1851 25.4366 31.1238 25.5692L28.4673 31.3208Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3633,
    y: 18.8569,
    width: 17.1428,
    height: 17.1429,
    rx: 3,
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8926 27.247C52.0474 27.3185 52.0474 27.5386 51.8926 27.6101L46.141 30.2667C46.0085 30.3279 45.8571 30.2311 45.8571 30.0851V24.772C45.8571 24.626 46.0085 24.5292 46.141 24.5905L51.8926 27.247Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 17.1428,
    height: 17.1429,
    rx: 3,
    transform: "matrix(-1 0 0 1 17.1429 18.8569)",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67881 27.6099C4.52396 27.5384 4.52396 27.3183 4.67881 27.2468L10.4304 24.5902C10.5629 24.529 10.7143 24.6258 10.7143 24.7718V30.0849C10.7143 30.2309 10.5629 30.3277 10.4304 30.2665L4.67881 27.6099Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAndRightArrowsMobile);
export default __webpack_public_path__ + "static/media/LeftAndRightArrowsMobile.d409da8cf1a7c37144d1eea115ffe763.svg";
export { ForwardRef as ReactComponent };